export const ChevronRight = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className="u-icon u-icon--utility-chevron-right"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9603 7.89869C12.18 8.11836 12.18 8.47446 11.9603 8.69414L6.22541 14.429C6.00573 14.6487 5.64963 14.6487 5.42996 14.429L5.16476 14.1638C4.94508 13.9442 4.94508 13.588 5.16476 13.3683L10.2367 8.29641L5.16476 3.22446C4.94508 3.00479 4.94508 2.64869 5.16476 2.42901L5.42996 2.16381C5.64963 1.94414 6.00573 1.94414 6.22541 2.16381L11.9603 7.89869Z"
      fill="currentColor"
    />
  </svg>
);
